// extracted by mini-css-extract-plugin
export var floatingContainer = "styles-module__floatingContainer___kpodF";
export var mapTip = "styles-module__mapTip___AFaVs";
export var mapTipClose = "styles-module__mapTipClose___nBXC9";
export var mapTipLink = "styles-module__mapTipLink___G05nt";
export var mapTipText = "styles-module__mapTipText___eRVfD";
export var mapTipTitle = "styles-module__mapTipTitle___Ytl2z";
export var tipContainer = "styles-module__tipContainer___PGhiG";